import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "photos" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-centered" }, "Check-In Photos")
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-centered" }, "Check-Out Photos")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Photos")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "row"
}
const _hoisted_11 = ["src", "data-src", "alt", "id"]
const _hoisted_12 = ["src", "data-src", "alt", "id"]
const _hoisted_13 = {
  key: 3,
  class: "scrollable"
}
const _hoisted_14 = ["src", "data-src", "alt"]
const _hoisted_15 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_16 = { class: "container-fluid" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn-group",
  role: "group",
  "aria-label": ""
}, null, -1)
const _hoisted_18 = {
  id: "status-bar-switches",
  style: {"margin-left":"auto","margin-right":"auto"}
}
const _hoisted_19 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Navigation"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-minus fa-rotate-90" }, null, -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-right" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-minus fa-rotate-90" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-left" }, null, -1)
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-minus fa-rotate-90" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]

import { ref, computed, onMounted, watch, inject, nextTick} from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import _ from 'lodash';
import _flattenDeep from 'lodash/flattenDeep';
import _cloneDeepWith from 'lodash/cloneDeepWith';
import _castArray from 'lodash/castArray';
import _get from 'lodash/get';
import { useRoute, useRouter } from 'vue-router';
import {
  Photo,
  LinkedPhoto,
  Report,
  Alarm,
  Meter,
  Key,
  Item,
  OrderedItem,
  Type,
  Section,
  Room,
  Compliancesection,
  Complianceitem,
} from "@/models";
import { ReportsState } from "@/store/reports/types";
import Viewer from "v-viewer";
import { api as viewerApi } from 'v-viewer'
import { useToast } from "vue-toastification";
import VueViewer, { component as VViewer } from 'v-viewer';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const toasted = useToast();
const actProperty: any = inject('actProperty');

const reportsState = computed((): ReportsState => store.state.reports);

const report = computed(() => store.getters['reports/current']);
const gallerydisplaymode = computed(() => store.getters['reports/gallerydisplaymode']);

const getReport = (id: string): Promise<any> => {
  return store.dispatch('reports/getReportUnauthenticated', id);
};

const setPhotos = (photos: LinkedPhoto[]) => {
  store.commit('reports/setPhotos', photos);
};

const setInphotos = (photos: LinkedPhoto[]): void => {
  store.commit('reports/setInphotos', photos);
};

const setCurrentinphoto = (photo: LinkedPhoto): void => {
  store.commit('reports/setCurrentinphoto', photo);
};

const setOutphotos = (photos: LinkedPhoto[]): void => {
  store.commit('reports/setOutphotos', photos);
};

const setCurrentoutphoto = (photo: LinkedPhoto): void => {
  store.commit('reports/setCurrentoutphoto', photo);
};

const setGallerydisplaymode = (mode: string): void => {
  store.commit('reports/setGallerydisplaymode', mode);
};

const cihighlightedphotos = ref<Photo[]>([]);
const cohighlightedphotos = ref<Photo[]>([]);
const ordereditems = ref<OrderedItem[]>([]);
const inphotoviewer = ref(null);
const outphotoviewer = ref(null);
const viewer = ref(null);
const _civiewer = ref<Viewer>();
const _coviewer = ref<Viewer>();
const _viewer = ref<Viewer>();

const cihighlight = (photo: Photo) => {
  const index = cihighlightedphotos.value.findIndex(
    (p) =>
      p.src === photo.src ||
      p.src.endsWith(photo.src) ||
      photo.src.endsWith(p.src)
  );
  return index > -1;
};

const cohighlight = (photo: Photo) => {
  const index = cohighlightedphotos.value.findIndex(
    (p) =>
      p.src === photo.src ||
      p.src.endsWith(photo.src) ||
      photo.src.endsWith(p.src)
  );
  return index > -1;
};

const photos = computed(() => reportsState.value.photos);
const inphotos = computed(() => reportsState.value.inphotos);
const currentinphoto = computed(() => reportsState.value.currentinphoto);
const outphotos = computed(() => reportsState.value.outphotos);
const currentoutphoto = computed(() => reportsState.value.currentoutphoto);

const viewerOptions = computed(() => {
  return {
    inline: false,
    toolbar: {
      zoomIn: "large",
      zoomOut: "large",
      prev: "large",
      next: "large",
      download: () => {
        downloadPhoto();
      },
    },
    url: "data-src",
    view: (event: any) => {
      console.log(event.detail.index);
    },
    viewed: (event: any) => {
      console.log(event.detail.index);
    },
    className: "",
  }
});

const invieweroptions = computed(() => {
  let options = _cloneDeepWith(viewerOptions.value);
  options.view = (event: any) => {
    let clickedphoto: LinkedPhoto = inphotos.value[event.detail.index];
    if (
      clickedphoto &&
      clickedphoto.linkedphotos &&
      clickedphoto.linkedphotos.length
    ) {
      setCurrentinphoto(clickedphoto);
      cohighlightedphotos.value = clickedphoto.linkedphotos;
      const firstlinkedphoto = clickedphoto.linkedphotos[0];
      const photoEl: HTMLElement | null = document.getElementById(
        `cophoto-${firstlinkedphoto.src}`
      );
      const topPos = photoEl?.offsetTop;
      const scrollableDiv = document.getElementById("coscrollablediv");
      if (scrollableDiv && topPos) scrollableDiv.scrollTop = topPos;
    } else {
      cohighlightedphotos.value = [];
    }
  };
  options.toolbar.download = () => {
    downloadPhoto(_civiewer.value);
  };
  if (displaymode.value === "center") options.className = "center-civiewer";
  else options.className = "only-civiewer";
  return options;
});

const outvieweroptions = computed(() => {
  let options = _cloneDeepWith(viewerOptions.value);
  options.view = (event: any) => {
    let clickedphoto: LinkedPhoto = outphotos.value[event.detail.index];
    if (
      clickedphoto &&
      clickedphoto.linkedphotos &&
      clickedphoto.linkedphotos.length
    ) {
      setCurrentoutphoto(clickedphoto);
      if (
        !_.isEmpty(
          _.xorWith(
            cihighlightedphotos.value,
            clickedphoto.linkedphotos,
            _.isEqual
          )
        )
      ) {
        // Item has changed
        // Hide CO photo
        _civiewer.value.hide();
      }
      cihighlightedphotos.value = clickedphoto.linkedphotos;
      const firstlinkedphoto = clickedphoto.linkedphotos[0];
      const photoEl: HTMLElement | null = document.getElementById(
        `ciphoto-${firstlinkedphoto.src}`
      );
      const topPos = photoEl?.offsetTop;
      const scrollableDiv = document.getElementById("ciscrollablediv");
      if (scrollableDiv && topPos) scrollableDiv.scrollTop = topPos;
    } else {
      cihighlightedphotos.value = [];
    }
  };
  options.toolbar.download = () => {
    downloadPhoto(_coviewer.value);
  };
  if (displaymode.value === "center") options.className = "center-coviewer";
  else options.className = "only-coviewer";
  return options;
});


const displaymode = computed({
  get: () => gallerydisplaymode.value,
  set: (mode: string) => {
    setGallerydisplaymode(mode);
  }
});

const civiewer = computed({
  get: () => _civiewer.value,
  set: (viewer: Viewer) => {
    _civiewer.value = viewer;
  }
});

const coviewer = computed({
  get: () => _coviewer.value,
  set: (viewer: Viewer) => {
    _coviewer.value = viewer;
  }
});

const baseviewer = computed({
  get: () => _viewer.value,
  set: (viewer: Viewer) => {
    _viewer.value = viewer;
  }
});

const ciViewerInit = (viewer: Viewer) => {
  civiewer.value = viewer;
  initViewer(viewer, inphotos.value, "ci");
}

const coViewerInit = (viewer: Viewer) => {
  coviewer.value = viewer;
  initViewer(viewer, outphotos.value, "co");
}

const viewerInit = (v: Viewer) => {
  baseviewer.value = v;
  initViewer(v, photos.value, "default");
}

const isCheckout = () => {
  return report.value && report.value.type === "checkout";
}

const initViewer = (viewer: Viewer, photosarray: LinkedPhoto[], cico: string) => {
  const { src, itemref } = route.params;
  if (src && src != "-") {
    // The src is base64 encoded, so let's decode it
    const base64DecodedSrc = new Buffer((src as string), "base64").toString("ascii");

    // Locate the Photo by matching on Photo.src
    const index = photosarray.findIndex(
      (x: LinkedPhoto) => x.src === base64DecodedSrc
    );

    viewphoto(viewer, index, cico);
  } else if (
    itemref &&
    itemref != "-" &&
    isCheckout() &&
    cico == 'co'
  ) {
    if (ordereditems.value && ordereditems.value.length) {
      let selecteditem = ordereditems.value.find(
        (item: OrderedItem) => item.order === parseInt(itemref as string)
      );
      if (selecteditem) {
        const cophotos = _get(selecteditem, `condition.out.photos`, []);
        if (cophotos && cophotos.length) {
          // Locate the Photo by matching on Photo.src
          const index = outphotos.value.findIndex(
            (x: LinkedPhoto) =>
              cophotos[0].src.endsWith(x.src) ||
              x.src.endsWith(cophotos[0].src)
          );
          if (index > -1) {
            const siblingphotos = outphotos.value.filter(
            (x: LinkedPhoto) => {
              const i = cophotos.findIndex((p) => x.src.endsWith(p.src) ||
              p.src.endsWith(x.src));
              return i >= 0;
            });
            cohighlightedphotos.value = siblingphotos;
            cihighlightedphotos.value = siblingphotos[0].linkedphotos;
            setTimeout(() => {
              if(cohighlightedphotos.value?.length > 0) {
                // Scroll CO side to the highlighted photo
                const coelement = document.getElementById(`cophoto-${cohighlightedphotos.value[0].src}`);
                if (coelement) {
                  coelement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                }
              }
              setTimeout(() => {
                // Scroll CI side to the highlighted photo
                if(cihighlightedphotos.value?.length > 0) {
                    const cielement = document.getElementById(`ciphoto-${cihighlightedphotos.value[0].src}`);
                    if (cielement) {
                      cielement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                    }
                  }
              }, 1000);
            }, 1000);
            
            //viewphoto(viewer, index, cico);
          }
        }
      }
    }
  }
}

const viewphoto = (viewer: Viewer, index: number, cico: string) => {
  if (index > -1) {
    if (
      cico === "ci" &&
      (displaymode.value === "left" || displaymode.value === "center")
    ) {
      viewer.view(index);
    } else if (
      cico === "co" &&
      (displaymode.value === "right" || displaymode.value === "center")
    ) {
      viewer.view(index);
    } else if (cico === "default") {
      viewer.view(index);
    }
  }
}

const downloadPhoto = (v?: Viewer) => {
  try {
    // Get current image title
    let photoViewer: any = v ? v : baseviewer.value;
    let imageTitle = photoViewer.title.innerHTML;
    // Only show the title text after the /
    let filteredTitle = imageTitle.lastIndexOf("/");

    let startOfTitle = imageTitle.substring(filteredTitle + 1);
    let end = startOfTitle.substr(0, startOfTitle.lastIndexOf("."));
    let newImageTitle = end.replace(/\d+-/g, "");

    let localviewer: any = v;
    if (!v) {
      localviewer = photoViewer;
    }

    let url = localviewer.image.src;
    let label = newImageTitle;

    // Download image as a jpeg
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "image/jpeg" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = label;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch(console.error);

    toasted.success(
      "Photo downloaded. Please check your downloads folder."
    );
  } catch (err) {
    console.error(err);
    toasted.error("Photo download failed. Please try again.");
  }
};

const init = async () => {
  await getReport(route.params.id as string).then(async (report: Report) => {
    if (report === undefined) {
      router.push({ name: "reportnotfound" });
    } else {
      ordereditems.value = getReportItems();
      const generalphotos: LinkedPhoto[] = getGeneralPhotos(report);

      if (report.type === "checkout") {
        const inkeyphotos: LinkedPhoto[] = getKeyPhotos("in");
        const outkeyphotos: LinkedPhoto[] = getKeyPhotos("out");
        const inroomphotos: LinkedPhoto[] = getRoomPhotos("in");
        const outroomphotos: LinkedPhoto[] = getRoomPhotos("out");
        setPhotos([...inkeyphotos, ...inroomphotos]);
        setInphotos([...inkeyphotos, ...inroomphotos]);
        setOutphotos([
          ...generalphotos,
          ...outkeyphotos,
          ...outroomphotos,
        ]);
      } else {
        const inkeyphotos: LinkedPhoto[] = getKeyPhotos("in");
        const compliancephotos: LinkedPhoto[] = getCompliancePhotos();
        const inroomphotos: LinkedPhoto[] = getRoomPhotos("in");
        setPhotos([
          ...generalphotos,
          ...compliancephotos,
          ...inkeyphotos,
          ...inroomphotos,
        ]);
      }

      if (route.params.type === "in") displaymode.value = "left";
      else if (route.params.type === "out") displaymode.value = "right";
      else displaymode.value = "center";
    }
  });
};

const getGeneralPhotos = (report: Report): LinkedPhoto[] => {
  // PDF Section: General Notes
  const propertyDetailsPhotos = _flattenDeep([
    ..._get(report, "propertyDetails.locationPhotos"),
    ..._get(report, "propertyDetails.cleaningReceiptPhotos"),
  ]).filter(Boolean);

  // PDF Section: Meter Readings
  const meters: Meter[] = _get(report, "meters", []);
  const meterPhotos = _flattenDeep(
    meters.map((meter: any) => meter.photos)
  ).filter(Boolean);

  // PDF Section: Safety Alarms
  const alarms: Alarm[] = _get(report, "alarms", []);
  const alarmPhotos = _flattenDeep(
    alarms.map((alarm: any) => alarm.photos)
  ).filter(Boolean);

  // PDF Section: Comments
  const commentPhotos = _flattenDeep([
    ..._get(report, "comments.tenantPhotos", ""),
    ..._get(report, "comments.clientPhotos", ""),
  ]).filter(Boolean);

  // Return one big array
  const allphotos: Photo[] = [
    ...propertyDetailsPhotos,
    ...meterPhotos,
    ...alarmPhotos,
    ...commentPhotos,
  ];

  return allphotos.map((photo: Photo) => new LinkedPhoto(photo));
}

const getKeyPhotos = (type: string): LinkedPhoto[] => {
  const oppositetype = type === "in" ? "out" : "in";
  const keys: Key[] = _get(report.value, "keys", []);
  const keyPhotos: LinkedPhoto[] = _flattenDeep(
    keys.map((key) => {
      const typephotos = _get(key, `photos.${type}`, []);
      const oppositetypephotos: any[] = _get(key, `photos.${oppositetype}`, []);
      if (typephotos && typephotos.length) {
        return typephotos.map((photo: Photo) => {
          return prepareLinkedphoto(photo, oppositetypephotos);
        });
      }
      return typephotos;
    })
  ).filter(Boolean);
  return keyPhotos;
}

const getCompliancePhotos = (): LinkedPhoto[] => {
  const compliancesections: Compliancesection[] = _get(
    report.value,
    "compliancesections",
    []
  );
  const compliancephotos: LinkedPhoto[] = _flattenDeep(
    compliancesections.map((compliancesection: Compliancesection) => {
      const complianceitems: Complianceitem[] =
        compliancesection.complianceitems;
      return complianceitems.map((complianceitem: Complianceitem) => {
        if (complianceitem.photos && complianceitem.photos.length) {
          return complianceitem.photos.map(
            (photo: Photo) => new LinkedPhoto(photo)
          );
        }
        return complianceitem.photos;
      });
    })
  );
  return compliancephotos;
}

const getRoomPhotos = (type: string): LinkedPhoto[] => {
  const oppositetype = type === "in" ? "out" : "in";
  const rooms: Room[] = report.value.rooms;
  const roomsPhotos: LinkedPhoto[] = _flattenDeep(
    rooms.map((room: Room) => {
      const sections: Section[] = room.sections;
      return sections.map((section: Section) => {
        const types: Type[] = section.types;
        return types.map((itemType: Type) => {
          const items: Item[] = itemType.items;
          return items.map((item: Item) => {
            const typephotos = _get(item, `condition.${type}.photos`, []);
            const oppositetypephotos = _get(
              item,
              `condition.${oppositetype}.photos`,
              []
            );
            if (typephotos && typephotos.length) {
              return typephotos.map((photo: Photo) => {
                return prepareLinkedphoto(photo, oppositetypephotos);
              });
            }
            return typephotos;
          });
        });
      });
    })
  ).filter(Boolean);
  return roomsPhotos;
}

const prepareLinkedphoto = (photo: Photo, photos: Photo[]): LinkedPhoto => {
  const linkedPhoto = new LinkedPhoto(photo);
  if (photos && photos.length) {
    photos.forEach((photo: Photo) => {
      linkedPhoto.addLinkedphoto(photo);
    });
  }
  return linkedPhoto;
}

const getReportItems = (): OrderedItem[] => {
  let items: OrderedItem[] = [];
  if (report.value && report.value.rooms) {
    report.value.rooms.forEach((room, roomindex) => {
      if (room.sections) {
        room.sections.forEach((section, sectionindex) => {
          if (section.types) {
            section.types.forEach((type, typeindex) => {
              if (type.items) {
                type.items.forEach((item, itemindex) => {
                  let orderedItem = new OrderedItem(item);
                  orderedItem.roomname = room.name;
                  orderedItem.roomindex = roomindex;
                  orderedItem.section = section.name;
                  orderedItem.sectionindex = sectionindex;
                  orderedItem.type = type.name;
                  orderedItem.typeindex = typeindex;
                  orderedItem.item = item;
                  orderedItem.itemindex = itemindex;
                  items.push(orderedItem);
                });
              }
            });
          }
        });
      }
    });
  }

  const orderedlist = items.map((item, order) => {
    item.order = order + 1;
    return item;
  });

  return orderedlist;
}

const moveDividerToLeft = () => {
  displaymode.value = "left";
}

const moveDividerToCenter = () => {
  displaymode.value = "center";
}

const moveDividerToRight = () => {
  displaymode.value = "right";
}

watch(() => route.params.id, (val, oldVal) => {
  if (route.params.id) {
    init();
  }
});

onMounted(() => {
  displaymode.value = "center";
  init();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((inphotos.value && inphotos.value.length) || (outphotos.value && outphotos.value.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (displaymode.value === 'left' || displaymode.value === 'center')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass({
        'col-md-6': displaymode.value === 'center',
        'col-md-12': displaymode.value === 'left',
        hide: displaymode.value === 'right',
      })
              }, _hoisted_4, 2))
            : _createCommentVNode("", true),
          (displaymode.value === 'right' || displaymode.value === 'center')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass({
        'col-md-6': displaymode.value === 'center',
        'col-md-12': displaymode.value === 'right',
        hide: displaymode.value === 'left',
      })
              }, _hoisted_6, 2))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)),
    ((inphotos.value && inphotos.value.length) || (outphotos.value && outphotos.value.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass(["scrollable", {
        'col-md-6': displaymode.value === 'center',
        'col-md-12': displaymode.value === 'left',
        hide: displaymode.value === 'right',
      }]),
            style: {"border-right":"5px solid #253746","display":"flex","text-align":"center"},
            id: "ciscrollablediv"
          }, [
            _createVNode(_unref(VViewer), {
              ref_key: "inphotoviewer",
              ref: inphotoviewer,
              options: invieweroptions.value,
              images: inphotos.value,
              rebuild: "",
              class: "pane",
              onInited: ciViewerInit
            }, {
              default: _withCtx((scope) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inphotos.value, (photo, index) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: index,
                    src: _unref(actProperty).resizedPhotoSrc(photo),
                    "data-src": _unref(actProperty).photoSrc(photo),
                    alt: _unref(actProperty).formatDatetimeForDisplay(photo.createdAt),
                    class: _normalizeClass(["gallery-image-size gallery-image-padding", {
                highlight: cihighlight(photo),
              }]),
                    id: `ciphoto-${photo.src}`
                  }, null, 10, _hoisted_11))
                }), 128))
              ]),
              _: 1
            }, 8, ["options", "images"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["scrollable", {
        'col-md-6': displaymode.value === 'center',
        'col-md-12': displaymode.value === 'right',
        hide: displaymode.value === 'left',
      }]),
            style: {"display":"flex","text-align":"center"},
            id: "coscrollablediv"
          }, [
            (outphotos.value && outphotos.value.length)
              ? (_openBlock(), _createBlock(_unref(VViewer), {
                  key: 0,
                  ref_key: "outphotoviewer",
                  ref: outphotoviewer,
                  options: outvieweroptions.value,
                  images: outphotos.value,
                  rebuild: "",
                  class: "pane",
                  onInited: coViewerInit
                }, {
                  default: _withCtx((scope) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(outphotos.value, (photo, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        key: index,
                        src: _unref(actProperty).resizedPhotoSrc(photo),
                        "data-src": _unref(actProperty).photoSrc(photo),
                        alt: _unref(actProperty).formatDatetimeForDisplay(photo.createdAt),
                        class: _normalizeClass(["gallery-image-size gallery-image-padding", {
                highlight: cohighlight(photo),
              }]),
                        id: `cophoto-${photo.src}`
                      }, null, 10, _hoisted_12))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["options", "images"]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (photos.value && photos.value.length)
            ? (_openBlock(), _createBlock(_unref(VViewer), {
                key: 0,
                ref_key: "viewer",
                ref: viewer,
                options: viewerOptions.value,
                images: photos.value,
                rebuild: "",
                class: "pane",
                onInited: viewerInit
              }, {
                default: _withCtx((scope) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: index,
                      src: _unref(actProperty).resizedPhotoSrc(photo),
                      "data-src": _unref(actProperty).photoSrc(photo),
                      alt: _unref(actProperty).formatDatetimeForDisplay(photo.createdAt),
                      class: "gallery-image-size gallery-image-padding"
                    }, null, 8, _hoisted_14))
                  }), 128))
                ]),
                _: 1
              }, 8, ["options", "images"]))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("nav", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              class: "btn btn-outline-light",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (moveDividerToLeft())),
              title: "Only show Check In photographs"
            }, _hoisted_22),
            _createElementVNode("button", {
              class: "btn btn-outline-light",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (moveDividerToCenter())),
              title: "Show Check In & Check Out photographs"
            }, _hoisted_26),
            _createElementVNode("button", {
              class: "btn btn-outline-light",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (moveDividerToRight())),
              title: "Only show Check Out photographs"
            }, _hoisted_29)
          ])
        ])
      ])
    ])
  ]))
}
}

})